import React, { useState } from 'react';
import { Translation } from 'react-i18next';
import { Module, Modules } from 'modules/security/types/modules';
import NavigationLink, { StyledNavigationLink } from './NavigationLink';
import { ImageFactory } from './NavigationSidebar';
import useImportedOrganizationsStore from '../../../importedOrganizations/services/useImportedOrganizationsStore';

type Props = {
  module: Module;
  isLaptopSM?: boolean;
  isTablet?: boolean;
  availableModules: Modules;
};

const SubNavigation: React.FC<Props> = ({ module, children: icon, availableModules, isLaptopSM, isTablet }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleNavigationItems = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  const openNavigationItems = () => {
    setIsOpen(true);
  };

  const { totalImportedOrganizations, getImportedOrganizations } = useImportedOrganizationsStore();
  const totalImportedOrganizationsLength = totalImportedOrganizations || '';

  React.useEffect(() => {
    if (availableModules.filter((module) => module.key === 'ImportOrganizations')) {
      getImportedOrganizations();
    }
  }, [availableModules, getImportedOrganizations]);

  return (
    <StyledNavigationLink isOpen={isOpen} isLaptopSM={isLaptopSM} isTablet={isTablet}>
      <a href="/" onClick={toggleNavigationItems} aria-expanded={isOpen} aria-controls={`submenu-${module.key}`}>
        {icon}
        <Translation ns="global">{(t) => <span>{t(`sidebar.${module.key}`)}</span>}</Translation>
      </a>
      <ul id={`submenu-${module.key}`}>
        {(module.subModules as Module[] | undefined)?.map((subModule) => {
          return (
            <NavigationLink
              badgeText={
                subModule.key === 'ImportOrganizations' && totalImportedOrganizationsLength != ''
                  ? totalImportedOrganizationsLength > 0
                    ? `- ${totalImportedOrganizationsLength.toString()}`
                    : ''
                  : ''
              }
              key={`${module.key}/${subModule.key}`}
              to={subModule.key}
              onFocus={openNavigationItems}
            >
              {ImageFactory[subModule.key]}
            </NavigationLink>
          );
        })}
      </ul>
    </StyledNavigationLink>
  );
};

export default SubNavigation;
